<template>
  <div id="app">
	<HeaderTop v-show="$route.meta.showHeaderTop"/>
<!--    <HeaderSearch v-show="$route.meta.showHeaderSearch"/>-->
<!--	  <keep-alive>-->
      <router-view :key="$route.fullPath"></router-view>
<!--    </keep-alive>-->
    <FaqFooter v-show="$route.meta.showFaqFooter"></FaqFooter>
    <ChatFooter v-show="$route.meta.showChatFooter"></ChatFooter>
    <Footer v-show="$route.meta.showFooter"></Footer>
  </div>
</template>

<script>
  import HeaderTop from './components/HeaderTop/HeaderTop'
  import Footer from "./components/Footer/Footer";
  import ChatFooter from "./components/Footer/ChatFooter";
  import FaqFooter from "./components/Footer/FaqFooter";
  import {mapActions} from 'vuex'
  import document from "./pages/Document/Document";

  export default {
    name: "App",
    mounted(){
      // let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      // if(userInfo){
      //   this.syncUserInfo(userInfo);
      // }
    },
    methods: {
      ...mapActions(['syncUserInfo']),
    },
    components:{
      HeaderTop,
      Footer,
      ChatFooter,
      FaqFooter,
    },
  }
</script>

<style scoped>
  #app{
    width: 100%;
    height: 100%;
    position: relative;
	  list-style: none;
  }
</style>
  }




// WEBPACK FOOTER //
// src/App.vue